export default "__VITE_ASSET__CucaHt5x__"